import { exampleFromLibrary } from "../utils/libraryExamples/exampleFromLibrary";

const libraryKeys = ["plotly", "marimo", "panel", "streamlit"] as const;

export type LibraryKey = (typeof libraryKeys)[number];

export function isLibraryKey(
  maybeLibraryKey: unknown
): maybeLibraryKey is LibraryKey {
  return (
    typeof maybeLibraryKey === "string" &&
    libraryKeys.some((libKey) => libKey === maybeLibraryKey)
  );
}

export class Library {
  readonly name: string;

  readonly key: LibraryKey;

  readonly port: number;

  readonly requirements: string[];

  constructor(
    name: string,
    key: LibraryKey,
    port: number,
    requirements: string[]
  ) {
    this.name = name;
    this.key = key;
    this.port = port;
    this.requirements = requirements;
  }

  get defaultApp(): string {
    return exampleFromLibrary(this.key);
  }
}

const plotly = new Library("Plotly-dash", "plotly", 8050, ["dash", "gunicorn"]);
const marimo = new Library("Marimo", "marimo", 8000, ["marimo"]);
const panel = new Library("Panel", "panel", 5006, ["panel"]);
const streamlit = new Library("Streamlit", "streamlit", 80, ["streamlit"]);

export const LibraryMap = {
  plotly,
  marimo,
  panel,
  streamlit
} as const;

export const Libraries = [...Object.values(LibraryMap)] as const;
